import { useMemo } from 'react';

const BLANK_OPTION = { value: '-blank-', label: '-blank-' };

export const useEnhancedOptions = (options, addBlank) => useMemo(() => {
  if (!addBlank) return options;
  return [BLANK_OPTION, ...(options || [])];
}, [options, addBlank]);
